import { render } from "./SubscribeRegister.vue?vue&type=template&id=3a93ceef&scoped=true"
import script from "./SubscribeRegister.vue?vue&type=script&lang=js"
export * from "./SubscribeRegister.vue?vue&type=script&lang=js"

import "./SubscribeRegister.vue?vue&type=style&index=0&id=3a93ceef&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a93ceef"]])

export default __exports__